import { useCustomerAuthRequest, LOGIN_TYPE } from 'hooks/useCustomerAuthApi/useCustomerAuthRequest';

type EmailAuthenticationRequestState = {
  hasPending: boolean;
  request: (emailAddress: string, redirectPath: string, reCaptchaToken?: RecaptchaToken) => Promise<undefined>;
  cancel: (message?: string) => void;
};

export type EmailAuthenticationRequestResult = EmailAuthenticationRequestState & [
  EmailAuthenticationRequestState['hasPending'],
  EmailAuthenticationRequestState['request'],
  EmailAuthenticationRequestState['cancel'],
];

export function useEmailAuthenticationRequest(): EmailAuthenticationRequestResult {
  return useCustomerAuthRequest((email: string, redirectPath: string, recaptcha?: RecaptchaToken) => {
    return email && redirectPath && ({
      method: 'POST',
      url: '/sessions/email/colo',
      data: {
        email,
        redirectPath,
        recaptcha,
        appLoginType: LOGIN_TYPE
      }
    });
  }, []);
}
